import { SvgIcon, SvgIconProps } from '@mui/material';

const MentorIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg height="800px" width="800px" version="1.3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <g fill="var(--mui-palette-text-secondary)">
          <path
            d="
            M505.8,180.4 
            C504,179 502,178 499,177 
            L279.3,76.1 
            C271,72 263,70 256,70 
            C249,70 241,72 232.7,76.1 
            L13,177 
            C10,178 8,179 6.2,180.4 
            C2.4,183 0,186 0,190 
            C0,194 2,197 6,199 
            L232.8,304 
            C240,308 248,310 256,310 
            C264,310 272,308 279.2,304 
            L458,221 
            Q470,215 470,230 
            V303 
            Q470,308 465,311 
            C459,315 456,320 456,326 
            Q456,332 460,336 
            L448,410 
            H498 
            L486,336 
            Q490,332 494,326 
            Q498,320 494,314 
            Q490,309 484,307 
            V208 
            Q508,198 512,190 
            Q512,183 505.8,180.4 
            Z"
          />

          <path
            d="
            M256,346.8 
            Q244,347 232,342 
            L112.8,288 
            V390 
            Q112.8,405 135,418 
            Q175,440 256,440 
            Q337,440 377,418 
            Q399.2,405 399.2,390 
            V288 
            L280,342 
            Q268,347 256,346.8 
            Z"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};

export default MentorIcon;
